import { __assign, __rest } from "tslib";
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { useViewModel } from '../hooks/useViewModel';
export var withViewModel = function (ViewModelClass) {
    return function (Component) {
        return (function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            var vm = useViewModel(ViewModelClass, props);
            var Comp = useMemo(function () { return observer(Component); }, [props]);
            return (React.createElement(Comp, __assign({}, props, { children: children, vm: vm })));
        });
    };
};
